import { cn } from '@nwwp/ui-shadcn'

export const BorderDoubleBox = ({ className }: { className?: string }) => {
  return (
    <div className={cn('flex size-5 flex-col', className)}>
      <div className="size-2.5 bg-corner-gradient" />
      <div className="size-2.5 self-end bg-corner-gradient" />
    </div>
  )
}
